module.exports = __webpack_public_path__ + "static/media/missing_bookable_mainphoto.f3d54b45.jpg";